/* ÉLINE L'ATELIER : sur ordinateur, les catégories du menu s'ouvrent au survol de la souris
   (un clic marche toujours, et le clavier aussi). */
(function () {
  // Menu téléphone : les photos se chargent dès l'ouverture du menu
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('header-drawer summary')) return;
    document.querySelectorAll('#menu-drawer img[loading="lazy"]').forEach(function (img) {
      img.loading = 'eager';
    });
  });

  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  function fermer(details) {
    if (!details.hasAttribute('open')) return;
    details.removeAttribute('open');
    var s = details.querySelector('summary');
    if (s) s.setAttribute('aria-expanded', 'false');
  }

  // Les photos du menu se chargent dès que la souris approche du menu (pas d'attente à l'ouverture)
  function precharger() {
    document.querySelectorAll('.eline-mega__photo img[loading="lazy"]').forEach(function (img) {
      img.loading = 'eager';
    });
  }

  function brancher() {
    var nav = document.querySelector('.header__inline-menu');
    if (nav && !nav.dataset.elinePrecharge) {
      nav.dataset.elinePrecharge = '1';
      nav.addEventListener('mouseenter', precharger, { once: true });
      nav.addEventListener('focusin', precharger, { once: true });
    }
    var menus = document.querySelectorAll('.header__inline-menu details.eline-mega');
    menus.forEach(function (details) {
      var li = details.closest('li');
      if (!li || li.dataset.elineSurvol) return;
      li.dataset.elineSurvol = '1';
      var minuteur;
      li.addEventListener('mouseenter', function () {
        if (window.innerWidth < 990) return;
        clearTimeout(minuteur);
        minuteur = setTimeout(function () {
          menus.forEach(function (autre) {
            if (autre !== details) fermer(autre);
          });
          if (!details.hasAttribute('open')) {
            details.setAttribute('open', '');
            var s = details.querySelector('summary');
            if (s) s.setAttribute('aria-expanded', 'true');
          }
        }, 90);
      });
      li.addEventListener('mouseleave', function () {
        clearTimeout(minuteur);
        minuteur = setTimeout(function () {
          fermer(details);
        }, 200);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', brancher);
  else brancher();
  document.addEventListener('shopify:section:load', brancher);
})();